import type { SVGProps } from "react";

export function QuestionIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 9H16M8 13H14M14 18H13L8 21V18H6C5.20435 18 4.44129 17.6839 3.87868 17.1213C3.31607 16.5587 3 15.7956 3 15V7C3 6.20435 3.31607 5.44129 3.87868 4.87868C4.44129 4.31607 5.20435 4 6 4H18C18.7956 4 19.5587 4.31607 20.1213 4.87868C20.6839 5.44129 21 6.20435 21 7V11.5M19 22V22.01M19 19C19.4483 18.9986 19.8832 18.8468 20.235 18.569C20.5868 18.2911 20.8352 17.9033 20.9406 17.4675C21.0459 17.0318 21.0019 16.5733 20.8158 16.1655C20.6297 15.7576 20.3122 15.424 19.914 15.218C19.5162 15.0142 19.0611 14.951 18.6228 15.0387C18.1845 15.1264 17.7888 15.3598 17.5 15.701"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
